import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

var IconFileKeynote = function IconFileKeynote(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 32 : _ref$height,
        title = _ref.title,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 32 : _ref$width;
    return React.createElement(
        AccessibleSVG,
        {
            className: 'icon-file-keynote ' + className,
            title: title,
            width: width,
            height: height,
            viewBox: '0 0 32 32'
        },
        React.createElement('path', { fill: '#fff', d: 'M25 27H7V5h13l5 5v17' }),
        React.createElement('path', {
            d: 'M20 4H7a.94.94 0 0 0-1 1v22a.94.94 0 0 0 1 1h18a.94.94 0 0 0 1-1V9.9zm5 23H7V5h13v4a.94.94 0 0 0 1 1h4z',
            fill: '#157ef8'
        }),
        React.createElement('path', {
            d: 'M21.19 18.24a.44.44 0 0 1-.09.12l-.12.09H10a.44.44 0 0 1-.12-.09.51.51 0 0 1-.09-.12.51.51 0 0 1 0-.14v-.6h11.5v.6a.48.48 0 0 1-.1.14zM10 17s.14-2.51.18-3.36v-.4a1.44 1.44 0 0 1 0-.2.65.65 0 0 1 .06-.19.66.66 0 0 1 .12-.16.63.63 0 0 1 .16-.11.65.65 0 0 1 .19-.06h.77v-.56a1.9 1.9 0 0 1 0-.26.83.83 0 0 1 .25-.49.72.72 0 0 1 .2-.13.94.94 0 0 1 .29-.09h1.48a.15.15 0 0 0 .13 0l.16-.22a.48.48 0 0 1 .12-.1l.16-.05h1.38l.16.05a.56.56 0 0 1 .14.1.52.52 0 0 1 .1.14.59.59 0 0 1 .06.16.71.71 0 0 1 0 .16 1 1 0 0 1 0 .23.58.58 0 0 1-.06.16.57.57 0 0 1-.24.24l-.16.06h-1.38a.63.63 0 0 1-.16-.05l-.1-.07-.16-.17a.17.17 0 0 0-.12-.07h-1.55a.35.35 0 0 0-.14.14.32.32 0 0 0 0 .1 1.06 1.06 0 0 0 0 .18v.57h8.27a.65.65 0 0 1 .19.06.65.65 0 0 1 .16.11.62.62 0 0 1 .12.16.65.65 0 0 1 .06.19 1.18 1.18 0 0 1 0 .2v.32c0 .65.18 3.43.18 3.43H10zm3 6.5h2V19h1v4.5h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z',
            fill: '#157ef8'
        })
    );
};

IconFileKeynote.propTypes = {
    className: PropTypes.string,
    height: PropTypes.number,

    /** A text-only string describing the icon if it's not purely decorative for accessibility */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    width: PropTypes.number
};
export default IconFileKeynote;
import PropTypes from 'prop-types';